import { useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'

import useCVNewStore from 'store/useCVNewStore'
import useOnboardingStore from 'store/useOnboardingStore'

const useBaseCVStep = () => {
  const { t } = useTranslation([
    'cv_form',
    'actions',
    'cv_modal',
    'inputs',
    'zod'
  ])

  const { data: session } = useSession()
  const jwt = session?.jwt

  const toggleShowErrorPopUp = useOnboardingStore(
    (state) => state.toggleShowErrorPopUp
  )
  const activeStep = useCVNewStore((state) => state.activeStep)
  const incStep = useCVNewStore((state) => state.incStep)
  const decStep = useCVNewStore((state) => state.decStep)
  const setMajorStep = useCVNewStore((state) => state.setMajorStep)
  const majorStep = useCVNewStore((state) => state.majorStep)
  const setStep = useCVNewStore((state) => state.setStep)
  const setTempCV = useCVNewStore((state) => state.setTempCV)
  const clearCV = useCVNewStore((state) => state.clearCV)
  const passedSteps = useCVNewStore((state) => state.passedSteps)
  const tempCV = useCVNewStore((state) => state.tempCV)
  const setModalAvatar = useCVNewStore((state) => state.setModalAvatar)
  const setModalBasic = useCVNewStore((state) => state.setModalBasic)
  const setModalLanguages = useCVNewStore((state) => state.setModalLanguages)
  const setModalWork = useCVNewStore((state) => state.setModalWork)
  const setModalIndustries = useCVNewStore((state) => state.setModalIndustries)
  const setModalEducation = useCVNewStore((state) => state.setModalEducation)
  const isEditing = useCVNewStore((state) => state.isEditing)
  const closeModals = useCVNewStore((state) => state.closeModals)
  const setModalPreferences = useCVNewStore(
    (state) => state.setModalPreferences
  )

  return {
    activeStep,
    incStep,
    decStep,
    setMajorStep,
    majorStep,
    setStep,
    passedSteps,
    session,
    setTempCV,
    clearCV,
    tempCV,
    jwt,
    t,
    setModalAvatar,
    setModalBasic,
    setModalLanguages,
    setModalEducation,
    setModalWork,
    setModalIndustries,
    isEditing,
    setModalPreferences,
    toggleShowErrorPopUp,
    closeModals
  }
}

export default useBaseCVStep
